import Sapphire from "../assets/images/gemtype-photos/sapphire.jpg";
import Ruby from "../assets/images/gemtype-photos/ruby.jpg";
import Aquamarine from "../assets/images/gemtype-photos/aquamarine.jpg";
import Tourmaline from "../assets/images/gemtype-photos/tourmaline.jpg";
import Morganite from "../assets/images/gemtype-photos/morganite.jpg";
import Tanzanite from "../assets/images/gemtype-photos/tanzanite.jpg";
import Emerald from "../assets/images/gemtype-photos/emerald.jpg";
import Garnet from "../assets/images/gemtype-photos/garnet.jpg";
import Citrine from "../assets/images/gemtype-photos/citrine.jpg";
import Alexandrite from "../assets/images/gemtype-photos/alexandrite.jpg";
import Amethyst from "../assets/images/gemtype-photos/amethyst.jpg";
import Zircon from "../assets/images/gemtype-photos/zircon.jpg";
import Spinel from "../assets/images/gemtype-photos/spinel.jpg";
import Topaz from "../assets/images/gemtype-photos/topaz.jpg";
import Kunzite from "../assets/images/gemtype-photos/kunzite.jpg";
import Heliodor from "../assets/images/gemtype-photos/heliodor.jpg";
import Opal from "../assets/images/gemtype-photos/opal.jpg";
import Apatite from "../assets/images/gemtype-photos/apatite.jpg";
import Iolite from "../assets/images/gemtype-photos/iolite.jpg";
import Sphene from "../assets/images/gemtype-photos/sphene.jpg";
import Peridot from "../assets/images/gemtype-photos/peridot.jpg";
import Beryl from "../assets/images/gemtype-photos/beryl.jpg";
import Ametrine from "../assets/images/gemtype-photos/ametrine.jpg";
import Moonstone from "../assets/images/gemtype-photos/moonstone.jpg";
import Chrysoberyl from "../assets/images/gemtype-photos/chrysoberyl.jpg";
import Quartz from "../assets/images/gemtype-photos/quartz.jpg";

// Interim, local, per-gem-type PHOTO set (bug #1807): the API has no gem-type-specific
// image yet (see src/helper/gemImage.js), so until real product photography is uploaded
// to blob storage (see Apps/Images/GemTypeImages/{gemtype}.jpg convention) we render a
// colour-accurate reference render keyed by GemTypeName instead of the diamond-shape
// icon the API currently returns. These are AI-generated reference renders (not actual
// inventory photos) pending sign-off before the same set is uploaded to blob storage.
const GEM_TYPE_ICONS = {
  SAPPHIRE: Sapphire,
  RUBY: Ruby,
  AQUAMARINE: Aquamarine,
  TOURMALINE: Tourmaline,
  MORGANITE: Morganite,
  TANZANITE: Tanzanite,
  EMERALD: Emerald,
  GARNET: Garnet,
  CITRINE: Citrine,
  ALEXANDRITE: Alexandrite,
  AMETHYST: Amethyst,
  ZIRCON: Zircon,
  SPINEL: Spinel,
  TOPAZ: Topaz,
  KUNZITE: Kunzite,
  HELIODOR: Heliodor,
  OPAL: Opal,
  APATITE: Apatite,
  IOLITE: Iolite,
  SPHENE: Sphene,
  PERIDOT: Peridot,
  BERYL: Beryl,
  AMETRINE: Ametrine,
  MOONSTONE: Moonstone,
  CHRYSOBERYL: Chrysoberyl,
  QUARTZ: Quartz,
};

export const getGemTypeIcon = (gemTypeName) => {
  if (!gemTypeName) return null;
  return GEM_TYPE_ICONS[String(gemTypeName).trim().toUpperCase()] || null;
};

export default GEM_TYPE_ICONS;
